let sailUsedDuringSSR = false;

export function markSailUsedForSSR(): void {
  if (typeof window === 'undefined') {
    sailUsedDuringSSR = true;
  }
}

export function wasSailUsedForSSR(): boolean {
  return sailUsedDuringSSR;
}

export function resetSailSSRFlag(): void {
  sailUsedDuringSSR = false;
}
